import service from "@/api/request";
export const checkSession = () => service.getByQuery("/courseAdmin/session/alive");
